import { render, staticRenderFns } from "./ItsForecastAdjustDetail.vue?vue&type=template&id=65ba2901&scoped=true&"
import script from "./ItsForecastAdjustDetail.vue?vue&type=script&lang=js&"
export * from "./ItsForecastAdjustDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ba2901",
  null
  
)

export default component.exports